import styled from 'styled-components';

export const QRContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  padding: 2rem;
`;

export const QRCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 600px;
  width: 100%;
`;

export const QRHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  
  h3 {
    margin: 1rem 0 0 0;
    color: #333;
    font-size: 1.5rem;
    font-weight: 600;
  }
`;

export const QRContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
`;

export const QRCodeImage = styled.div`
  img {
    max-width: 200px;
    max-height: 200px;
    border-radius: 8px;
  }
`;

export const QRInstructions = styled.div`
  h4 {
    margin: 0 0 1rem 0;
    color: #333;
    font-size: 1.1rem;
    font-weight: 600;
  }
`;

export const QRStep = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
  
  .step-number {
    background: #00C48C;
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
    margin-top: 2px;
  }
  
  span:last-child {
    color: #666;
    line-height: 1.5;
    
    strong {
      color: #333;
      font-weight: 600;
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  
  span {
    color: #666;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  
  span {
    color: #666;
    font-size: 1rem;
  }
`;
